import { TILE_SIZES, type TileSize } from 'dibs-buyer-product-tile/exports/BuyerProductTile.ts';
import { type ScrollPadding } from 'dibs-scroll-carousel/exports/types.ts';
import { spacing } from 'dibs-sassy/exports/spacing.ts';

import {
    FEED_CAROUSEL_ITEMS_TO_SHOW_MOBILE,
    FEED_CAROUSEL_ITEMS_TO_SHOW_RESP,
} from '../../PdpInfiniteScrollGrid/pdpInfiniteScrollGridConstants.ts';

const getTileSize = ({ isMobile, compact }: { isMobile: boolean; compact: boolean }): TileSize => {
    if (isMobile) {
        return TILE_SIZES.small;
    }
    return compact ? TILE_SIZES.smaller : TILE_SIZES.medium;
};

export const getPdpFeedCarouselLayout = ({
    isMobile,
    compact = false,
}: {
    isMobile: boolean;
    compact?: boolean;
}): {
    itemsToShow: number;
    stepSize: number;
    showArrows: boolean;
    arrowVariant: 'overlay' | undefined;
    gapSize: 'xSmall' | 'small';
    shouldAdjustFlexBasis: boolean;
    itemFlexBasis: string | undefined;
    scrollPadding: ScrollPadding;
    edgeFade: boolean;
    tileSize: TileSize;
} => {
    return {
        itemsToShow: isMobile
            ? FEED_CAROUSEL_ITEMS_TO_SHOW_MOBILE
            : FEED_CAROUSEL_ITEMS_TO_SHOW_RESP,
        stepSize: isMobile ? 1 : FEED_CAROUSEL_ITEMS_TO_SHOW_RESP,
        showArrows: !isMobile,
        arrowVariant: isMobile ? undefined : 'overlay',
        gapSize: isMobile ? 'xSmall' : 'small',
        shouldAdjustFlexBasis: !isMobile,
        // --feed-tile-width is owned by PdpSharedFeedCarouselFrame.module.css. Carousel items use
        // border-box + half-gap padding, so add the gap back to keep the tile at its pinned width.
        itemFlexBasis: isMobile
            ? `calc(var(--feed-tile-width, 160px) + ${spacing.sassySpacingXSmall})`
            : undefined,
        scrollPadding: isMobile ? 'smallEdges' : 'none',
        edgeFade: isMobile,
        tileSize: getTileSize({ isMobile, compact }),
    };
};
